const formatCurrency = amount => {
  return `$${Number(amount)
    .toFixed(0)
    .replace(/\d(?=(\d{3})+)/g, '$&,')}`
}

export default formatCurrency
